// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"552":"1c3f641e","858":"4b08d1ea"}[chunkId] + ".chunk.js";
};